import React, {type ReactNode} from 'react'
import {Category} from '@duesyco/shared'

interface Props {
    category: Category;
    testId?: string;
}

export default function EventCategoryPill(
    {
        category,
        testId = undefined,
    }: Props): ReactNode {
    return <span
        className="inline-flex items-center text-xs px-2 py-1 rounded-full bg-storm-90 text-gray-900 text-nowrap ring-1 ring-gray-500/5 ring-inset"
        data-testid={testId}
    >
        {category.name}
    </span>
}
